import axios from 'axios'
import Vue from 'vue'
export default {
	namespaced: true,
	state: {
		listado: []
	},
	getters: {
		listado (state) {
			const arr = [].concat(state.listado)
			return arr.sort((a, b) => {
				if (a.FechaCreacion > b.FechaCreacion) {
					return -1
				} else if (a.FechaCreacion < b.FechaCreacion) {
					return 1
				}
				return 0
			})
		},
		nuevas (state) {
			return state.listado.filter(noti => {
				if (!noti.FechaMostrada) {
					return true
				}
				return false
			})
		}
	},
	mutations: {
		ADD (state, payload) {
			for (let i = 0; i < state.listado.length; i++) {
				if (state.listado[i].NotificacionID === payload.NotificacionID) {
					Vue.set(state.listado, i, payload) // Actualizamos
					return
				}
			}

			state.listado.splice(0, 0, payload)
		},
		DEL (state, payload) {
			state.listado = state.listado.filter(n => n.NotificacionID !== payload)
		},
		DEL_TODAS (state) {
			state.listado = []
		},
		LEIDAS (state) {
			for (let i = 0; i < state.listado.length; i++) {
				if (!state.listado[i].FechaMostrada) {
					state.listado[i].FechaMostrada = Math.floor(new Date().getTime() / 1000)
					Vue.set(state.listado, i, state.listado[i])
				}
			}
		}
	},
	actions: {
		get (context) {
			axios.get('core/php/api/notificaciones/getNotificaciones.php')
				.then(res => {
					if (res && res.data) {
						res.data.forEach(noti => {
							context.commit('ADD', noti)
						})
					}
					context.dispatch('poll')
				})
				.catch(e => {
					console.error(e)
				})
		},
		poll (context) {
			const LastID = context.state.listado.reduce((acc, item) => {
				acc = (acc === null || acc < item.NotificacionID) ? item.NotificacionID : acc
				return acc
			}, null)
			const ajax = new XMLHttpRequest()
			ajax.open('GET', 'src/modulos/core/php/api/notificaciones/polling_notificaciones.php?LastID=' + LastID, true)
			ajax.onreadystatechange = () => {
				if (ajax.readyState === 4) {
					if (ajax.status === 200) {
						const res = JSON.parse(ajax.responseText)
						res.forEach(noti => {
							context.commit('ADD', noti)
						})
						context.dispatch('poll')
					} else {
						console.error(ajax.response)
						window.setTimeout(() => {
							context.dispatch('poll')
						}, 30000)
					}
				}
			}
			ajax.send()
		},
		del (context, NotificacionID) {
			axios.post('core/php/api/notificaciones/descartar.php?NotificacionID=' + NotificacionID)
				.then(res => {
					context.commit('DEL', NotificacionID)
				})
				.catch(e => {
					console.log(e)
					console.error('Error descartando la notificación')
				})
		},
		delTodas (context) {
			axios.get('core/php/api/notificaciones/descartarTodas.php')
				.then(() => {
					context.commit('DEL_TODAS')
				})
				.catch(e => {
					console.log(e)
				})
		},
		leidas (context) {
			axios.post('core/php/api/notificaciones/leidas.php', {ids: context.state.listado.map(l => l.NotificacionID)})
				.then(res => {
					context.commit('LEIDAS')
				})
				.catch(e => {
					console.log(e)
					console.error('Error descartando la notificación')
				})
		}
	}
}



// WEBPACK FOOTER //
// ./src/modulos/core/vue/store/notificaciones.js